export const infos = {
	goBack: "Volver a listas",
	import: "Importar hoja de cálculo",
	addGuest: "Agregar invitado",
	edit: "Editar información",
	download: "Descargar lista",
	print: "Imprimir",
	search: "Buscar invitado o promotor",
	entrances: {
		label: "Entrada asociada",
		empty: "Sin entrada asociada",
		error: "Sin entrada asociada a esta lista",
	},
	couvert: "Descuento Cover",
	expires: "Expiración",
	description: {
		label: "Descripción",
		empty: "Sin descripción agregada",
	},
	guest: "Invitado",
	guests: "Invitados",
	editInfos: "Editar información de la lista",
	editGuest: "Editar invitado",
	emptyList: {
		defaultMessage: "Parece que no ha registrado ningún invitado",
		text: "La lista con los invitados aparecerá aquí cuando tenga invitados registrados.",
		importList: "Importar lista",
	},
	editModal: {
		title: "Editar lista",
		new: "Nueva lista",
		name: {
			label: "Nombre de la lista",
			placeholder:
				"Especifique su lista de modo que identifique rápidamente (nombre de la lista - evento - fecha - local)",
		},
		expiresAt: "Expiración de la lista",
		color: "Asignar un color",
		couvert: "Descuento en el cover",
		entrance: {
			label: "Entrada asociada",
			placeholder: "Escriba o seleccione el tipo de entrada",
		},
		description: {
			label: "Descripción",
			placeholder: "Agregue una observación para su lista si lo desea",
			limit: "Quedan {{limit}} caracteres",
		},
		errors: {
			emptyName: "Ingrese el nombre de la lista",
			length: "El nombre de la lista debe tener menos de 100 caracteres",
			expires: "Fecha y hora expirada",
			description: "La descripción de la lista debe tener menos de 280 caracteres",
		},
		save: "Guardar edición",
	},
	addGuestModal: {
		name: {
			label: "Nombre y apellido",
			placeholder: "Nombre completo del cliente",
			error: "Nombre inválido",
		},
		cpf: {
			label: "RFC",
			error: "RFC inválido",
		},
		phone: "Teléfono",
		promoter: {
			label: "Promotor",
			placeholder: "Escriba el nombre del promotor",
		},
	},
	columns: {
		name: "Nombre",
		cpf: "RFC",
		phone: "Teléfono",
		promoter: "Promotor",
		actions: "Acciones",
		emptyText: "Sin datos para mostrar.",
	},
};
